export default "__VITE_ASSET__BHUvgHoc__"